import { Routes } from '@angular/router';
import { ErrorComponent } from './404.component';

export const ErrorRoutes: Routes = [
  {
    path: 'miscellaneous/error',
    component: ErrorComponent,
    title: '404 | ADROIT',
  },
];
